export default "__VITE_ASSET__QwwYJQDE__"